import React from "react";
import "../App.css";
import { Pagination } from "./Pagination";

export function Footer({
  pageCount,
  pageNumber,
  onPageChange,
}) {
  return (
    <div className="footer">
      <Pagination
        pageCount={pageCount}
        pageNumber={pageNumber}
        onPageChange={onPageChange}
      />
    </div>
  );
}
